var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCalander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0C11.5815 0 11.8995 0.131696 12.1339 0.366116C12.3683 0.600537 12.5 0.918479 12.5 1.25V5H27.5V1.25C27.5 0.918479 27.6317 0.600537 27.8661 0.366116C28.1005 0.131696 28.4185 0 28.75 0C29.0815 0 29.3995 0.131696 29.6339 0.366116C29.8683 0.600537 30 0.918479 30 1.25V5H34.5833C36.1933 5 37.5 6.30667 37.5 7.91667V34.5833C37.5 35.3569 37.1927 36.0987 36.6457 36.6457C36.0987 37.1927 35.3569 37.5 34.5833 37.5H5.41667C4.64312 37.5 3.90125 37.1927 3.35427 36.6457C2.80729 36.0987 2.5 35.3569 2.5 34.5833V7.91667C2.5 6.30667 3.80667 5 5.41667 5H10V1.25C10 0.918479 10.1317 0.600537 10.3661 0.366116C10.6005 0.131696 10.9185 0 11.25 0ZM35 15.8333H5V34.5833C5 34.8133 5.18667 35 5.41667 35H34.5833C34.6938 35 34.7998 34.9561 34.878 34.878C34.9561 34.7998 35 34.6938 35 34.5833V15.8333ZM5.41667 7.5C5.30616 7.5 5.20018 7.5439 5.12204 7.62204C5.0439 7.70018 5 7.80616 5 7.91667V13.3333H35V7.91667C35 7.80616 34.9561 7.70018 34.878 7.62204C34.7998 7.5439 34.6938 7.5 34.5833 7.5H5.41667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCalander);
export default __webpack_public_path__ + "static/media/DashboardCalander.2a56a351ae1cd8bc3b7829e296a17e45.svg";
export { ForwardRef as ReactComponent };